const defaultGateway = () => ({
  name: '',
  usage: '',
  proxy: '',
  schema: {},
  enable: true,
});

export default defaultGateway;
